var React = require('react');

function LinkArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_1613","data-name":"Group 1613","transform":"translate(-1079.202 -960.236)"},[React.createElement("path",{"id":"Path_9","data-name":"Path 9","d":"M1099.355,960.59l5.53,5.53-5.53,5.53","fill":"none","stroke":"#fff","strokeWidth":"1","key":0}),React.createElement("path",{"id":"Path_10","data-name":"Path 10","d":"M1079.2,966.12h25.1","fill":"none","stroke":"#fff","strokeWidth":"1","key":1})]));
}

LinkArrow.defaultProps = {"width":"26.391","height":"11.768","viewBox":"0 0 26.391 11.768"};

module.exports = LinkArrow;

LinkArrow.default = LinkArrow;
